import { ReactNode } from 'react';
import {
  SxProps,
  TableFooter as MUITableFooter,
  TableFooterProps as MUITableFooterProps,
} from '@mui/material';

import layout from '@atom/styles/layout';

type CustomProps = {
  /**
   * width of the pagination component.
   * since it is absolutely positioned percentage widths reflect percentage of the entire viewport.
   * defaults to calc(100vw - layout.sidePaneWidth)
   */
  width?: string | number;
};

type AtomMUIProps = {
  children?: ReactNode;
};

type TableFooterProps = CustomProps & AtomMUIProps;

const TableFooter = (props: TableFooterProps) => {
  const { width = `calc(100vw - ${layout.sidePaneWidth})`, ...data } = props;

  const sx: SxProps = {
    width,
    position: 'absolute',
    bottom: 0,
    background: 'white',
    display: 'flex',
    justifyContent: 'flex-end',
    overflow: 'hidden',
  };

  const MUIProps: MUITableFooterProps = data;

  return <MUITableFooter sx={sx} {...MUIProps} />;
};

export default TableFooter;
